import {
  mapOrderByFieldToColumn,
  mapSelectedGroupFilterToInput,
  mapSelectedProfileFieldsToInput,
} from "@/product/member/page/ProductMembersListPageToolbar"
import { ProductMembersListToolbarState } from "@/product/member/page/useProductMembersListToolbarState"
import { ProductMembershipsExportCsvButtonFragment$key } from "@/product/member/page/__generated__/ProductMembershipsExportCsvButtonFragment.graphql"
import { ProductMembershipsExportCsvButtonMutation } from "@/product/member/page/__generated__/ProductMembershipsExportCsvButtonMutation.graphql"
import Relay from "@/relay/relayUtils"
import { displayErrorToast } from "@components/toast/ToastProvider"
import { DiscoButton } from "@disco-ui"
import { useState } from "react"
import { useFragment } from "react-relay"
import { graphql } from "relay-runtime"

interface Props {
  productKey: ProductMembershipsExportCsvButtonFragment$key
  toolbarState: ProductMembersListToolbarState
}

function ProductMembershipsExportCsvButton({ productKey, toolbarState }: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const product = useFragment<ProductMembershipsExportCsvButtonFragment$key>(
    graphql`
      fragment ProductMembershipsExportCsvButtonFragment on Product {
        id
      }
    `,
    productKey
  )

  const createCSVMutation =
    Relay.useAsyncMutation<ProductMembershipsExportCsvButtonMutation>(
      graphql`
        mutation ProductMembershipsExportCsvButtonMutation(
          $input: CreateProductMembershipsCSVDataInput!
        ) {
          response: createProductMembershipsCSVData(input: $input) {
            downloadCSVLink
            errors {
              field
              message
            }
          }
        }
      `
    )

  return (
    <DiscoButton
      color={"grey"}
      variant={"outlined"}
      onClick={handleExportCSVClick}
      shouldDisplaySpinner={isSubmitting}
    >
      {"Export CSV"}
    </DiscoButton>
  )

  async function handleExportCSVClick() {
    // Call mutation to handle this on the backend, return string
    try {
      setIsSubmitting(true)
      const { response: mutationResponse } = await commitMutation()

      if (mutationResponse.downloadCSVLink) {
        window.location.href = mutationResponse.downloadCSVLink
      }
    } catch (error) {
      displayErrorToast(error)
    }
    setIsSubmitting(false)
  }

  function commitMutation() {
    return createCSVMutation({
      input: {
        productId: product.id,
        search: toolbarState.search,
        roles: toolbarState.selectedRole?.value
          ? [toolbarState.selectedRole.value]
          : null,
        memberGroupFilterInput: mapSelectedGroupFilterToInput(toolbarState),
        profileFields: mapSelectedProfileFieldsToInput(toolbarState),
        orderBy: {
          field: mapOrderByFieldToColumn(toolbarState.sort.order.field),
          direction: toolbarState.direction,
        },
      },
    })
  }
}

export default ProductMembershipsExportCsvButton
